'use strict'

import css from './ums-max-container.styles.scss'

export const umsMaxContainer = {
  transclude: true,
  template: `
    <div layout="row" layout-align="center" flex>
      <div flex flex-sm="95" flex-gt-sm="90">
        <div class="${css.content}" ng-transclude flex layout="column"></div> 
      </div>
    </div>
  `,
}



// WEBPACK FOOTER //
// ./app/shared/components/max-container/ums-max-container.component.js